function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class RequestError extends Error {
    getRequestUrl(err) {
        var _err_response_request, _err_response, _err_response_req, _err_response1;
        // @ts-expect-error - superagent types do not reflect the existence of the req property
        return ((_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_request = _err_response.request) === null || _err_response_request === void 0 ? void 0 : _err_response_request.url) || ((_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : (_err_response_req = _err_response1.req) === null || _err_response_req === void 0 ? void 0 : _err_response_req.url);
    }
    constructor(err){
        super(err.toString()), _define_property(this, "status", void 0), _define_property(this, "statusCode", void 0), _define_property(this, "name", void 0), _define_property(this, "message", void 0), _define_property(this, "stack", void 0);
        const requestUrl = this.getRequestUrl(err);
        this.message = `failed requesting ${requestUrl}: ${err.message}; status code ${err.status}`;
        this.status = err.status;
        this.statusCode = err.status;
        this.name = err.name;
        this.stack = err.stack;
    }
}
export default RequestError;
